// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Wise */
export const Wise = createBankIcon({
  name: "Wise",
  slug: "wise",
  compe: null,
  color: "#9fe870",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#9fe870;fill-opacity:1\"\n     id=\"wise_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,21.0155) scale(2.41667)\">\n    <path d=\"M 6.488,7.469 L 0,15.05 l 11.585,0 l 1.301,-3.576 L 7.922,11.474 l 3.033,-3.507 l 0.01,-0.092 L 8.993,4.48 l 8.873,0 l -6.878,18.925 l 4.706,0 L 24,0.595 L 2.543,0.595 l 3.945,6.874 Z\" style=\"fill:#163300\" fill-rule=\"evenodd\" />\n  </g>",
});
